import { Injectable } from '@angular/core';
import {CordovaService} from '../cordova/cordova.service';


export type RESULT_SPICE = {
  pitches: Array<number>;
  uncertainties: Array<number>;
};

@Injectable({
  providedIn: 'root'
})
export class TfSpiceService {

  private inited = false;

  constructor(
    private cordovaSvc: CordovaService,
  ) { }

  public init(): Promise<void> {
    if (!this.inited) {
      return new Promise<void>((resolve, reject) => {
        this.cordovaSvc.exec(() => {
          this.inited = true;
          resolve();
          }, reject, 'TFLiteSpice', 'initMethod', null);
      });
    }
    else {
      return Promise.resolve();
    }
  }

  public cool(message: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.cordovaSvc.exec(
        resolve,
        reject,
        'TFLiteSpice',
        'coolMethod',
        [message]
      );
    });
  }

  public predict(float32Array: Float32Array): Promise<RESULT_SPICE> {
    const abChannel: ArrayBuffer = float32Array.buffer;
    console.log('predict abChannel = ', abChannel);
    // const fArray = Array.from(float32Array);
    // console.log('predict fArray = ', fArray);

    return new Promise<RESULT_SPICE>((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject('TfSpiceService::predict(): Timeout');
      }, 5000); // 5초 타임아웃 설정

      this.cordovaSvc.exec(
        (...args) => {
          clearTimeout(timeoutId); // 타임아웃 해제
          console.log('predict =', args);
          const pitches: Array<number> = Array.from(new Float32Array(args[0]));
          const uncertainties: Array<number> = Array.from(new Float32Array(args[1]));
          // console.log('pitches = ', pitches, 'uncertainties = ', uncertainties);
          if (pitches.length === uncertainties.length) {
            resolve({pitches, uncertainties});
          }
          else {
            reject('TfSpiceService::predict(): the size of pitches and uncertainties are not same!!!');
          }
        },
        (error) => {
          clearTimeout(timeoutId); // 타임아웃 해제
          reject(error);
        },
        'TFLiteSpice',
        'predictMethod',
        [abChannel]);
    });
  }
}
